<div [ngClass]="{'file-upload-container': !validateWarning(), 'file-upload-container-warning': validateWarning()}">

<!-- 
  <div class="file-group--container" *ngIf="isImg && filesImg.length > 0">
    <div class="file-upload-view--container" *ngFor="let img of filesImg; let i = index">
      <div *ngIf="img.src && img.src !== ''" class="file-upload-view--contain">
        <a target="_blank" [href]="img.src" class="file-thumbaline-view">
          <div *ngIf="img.type == 'application/pdf'" class="file-upload-view file-pdf"></div>
          <img *ngIf="img.type != 'application/pdf'" class="file-upload-view" [src]="img.src" [alt]="'archivo' + i" />
        </a>
        <mat-icon (keydown)="deleteImg(i)" (click)="deleteImg(i)" class="file-upload-view-icon"> delete </mat-icon>
      </div>
    </div>
  </div> -->
  <!-- <div *ngIf="!isImg && filesImg.length > 0">
    <div class="file-upload-document--contain" *ngFor="let file of filesImg; let i = index">
      <p class="file-upload-view--document">
        {{ file.name }}
      </p>
      <mat-icon (keydown)="deleteImg(i)" (click)="deleteImg(i)"> delete </mat-icon>
    </div>
  </div> -->

  <div class="file-input-container">
    <div class="input-wrapper">
      <div style="display: flex; align-items: center; gap: 10px;">
        <img *ngIf="filesImg.length >= 1 && !validateWarning()" src="assets/icons/Check_circular_On.svg" alt="check-circle">
        <mat-icon  *ngIf="validateWarning()" style="color: #DE0B1C;">warning</mat-icon>
        <p class="file-upload--label">
          {{ labelText }}
        </p>
      </div>
    <p *ngIf="filesImg.length == 0" class="subtitle-text"> {{ subtitle }} </p>
    <input
    #fileInput
    accept="image/*,application/pdf"
    [attr.capture]="useCamera ? 'camera' : null"
    [disabled]="oneFile && filesImg.length == 1"
    type="file"
    class="input-file"
    [id]="id"
    (change)="onFileSelected($event)"
  />
    <div class="file-item" *ngFor="let file of filesImg; let i = index">
      <p class="file-name"> {{ fileNameWithoutTime }} </p>
      <img (keydown)="deleteImg(i)" (click)="deleteImg(i)" *ngIf="filesImg.length >= 1" src="assets/icons/Delete.svg" alt="check-circle">
      <!-- <mat-icon (keydown)="deleteImg(i)" (click)="deleteImg(i)" *ngIf="filesImg.length >= 1" class="delete-icon">delete_outline</mat-icon> -->
      <!-- <button class="button-upload" (click)="openFileDialog()"> Editar </button> -->
    </div>
    </div>
      <div class="button-wrapper">
        <button *ngIf="!oneFile || (oneFile && filesImg.length < 1)" class="button-upload" (click)="openFileDialog()">Adjuntar</button>
        <!-- <mat-icon *ngIf="oneFile && filesImg.length == 1" class="check-icon">check_circle</mat-icon> -->
      </div>
  </div>



<!--   
  <div
    *ngIf="!oneFile || (oneFile && filesImg.length < 1)"
    class="file-upload"
    (keydown)="openFileDialogOnKeyDown($event)"
    (click)="openFileDialog()"
  >
    <div class="file-upload--content">
      <p *ngIf="!oneFile || (oneFile && filesImg.length < 1)" class="file-upload--extension">
        Extensiones: {{ extensionsText }} / Max Size: {{ maxSizeFile }} Mb
      </p>
      <p *ngIf="oneFile && filesImg.length == 1" class="file-upload--extension">
        {{ this.filesImg[0].name }}
      </p>
      <div class="file-upload--drop">
        <span> Para adjuntar haga click o arrastre aquí el o los archivos </span>
      </div>
    </div>
  </div> -->

  <!-- <label class="warning-label" *ngIf="validateWarning()">Debe adjuntar este archivo</label> -->
</div>
